import React from 'react'

const Error404 = () => {
  const logoMinisoURL ="https://minisolove.miniso.com.mx/logoMinisoNoBG.png"
  return (
    <div style={{height:'100vh', width:'100vw'}} className='d-flex flex-column justify-content-center'>
      <div
    className='alert alert-danger d-flex flex-column justify-content-center align-items-center w-100'>
      <div className='d-flex gap-2 justify-content-center align-items-center'>
      <img style={{width:"50px"}} 
        src={logoMinisoURL} alt="Miniso" />
      <h3 className=' fs-3'>
      Error404
      </h3>
      </div>
      <h6 className=''>Este error puede ser por que se intenta acceder a una ruta sin autorización o esta no existe</h6>
    </div>
    </div>
  )
}

export default Error404